<template>  
  <v-layout>
    <v-btn @click="getSims(1)" disabled>Sync SIMS</v-btn>
    <v-btn @click="getCalamps()">Sync CALAMP</v-btn>
  </v-layout>
</template>

<script>
import { fireStore } from '../firebase'
export default {
  data () {
    return {
      apiDetails: {}
    }
  },
  mounted () {
    this.$store.dispatch('fetchCustomers')
    this.$store.dispatch('fetchVehicles')
    fireStore.collection('apiDetails').get()
      .then(snap => {
        snap.forEach(doc => {
          this.apiDetails = doc.data()
        })
      })
  },
  methods: {
    getCalamps () {
      let calamps = []
      fireStore.collection('Jobs').where('templates', 'array-contains', '51KKtGhMyZ3aaVqYtS0u').where('Status', '==', 3).get()
        .then(snap => {
          snap.forEach(doc => {
            let data = doc.data()
            if (data.extras && data.Vehicle && data.extras['[Track Smart] Calamp ESN No*']) {
              calamps.push({
                CustomerName: this.customers.find(v => v.key === data.Customer).name,
                VehicleReg: this.vehicles.find(v => v.key === data.Vehicle).VehicleReg,
                installed: data.CompletedDate,
                id: doc.id,
                stockLocation: 'Installed',
                vehicle: data.Vehicle,
                customer: data.Customer,
                'ESN No*': data.extras['[Track Smart] Calamp ESN No*'],
                'IMEI': data.extras['[Track Smart] Calamp IMEI'],
                'SIM': data.extras['[Track Smart] Sim Card  Number*'],
                'Config Version': data.extras['[Track Smart] Config  Version'],
                product: '51KKtGhMyZ3aaVqYtS0u',
                finance: data.finance ? data.finance['51KKtGhMyZ3aaVqYtS0u'] : {}
              })
            }
          })
          console.log(calamps)
        })
    },
    async getSims (loop) {
      let response = await fetch('https://api.m2m.vodafone.com/m2m/v2/oauth2/access-token', {
        method: 'POST',
        body: `grant_type=password&username=${this.apiDetails.username}&password=${this.apiDetails.password}&scope=M2M_CUSTOMERS_ALL M2M_NETWORK_ALL M2M_DEVICES_ALL`,
        headers: {
          'Authorization': `Basic ${this.apiDetails.key}`,
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      let result = await response.json()

      var myHeaders = {
        'Authorization': `Bearer ${result.access_token}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }

      let method = 'POST'
      let url = `https://api.m2m.vodafone.com/m2m/v1/devices/list`

      let raw = JSON.stringify(
        {
          'getFilteredDeviceList': {
            'pageSize': 500,
            'pageNumber': loop
          }
        }
      )

      var requestOptions = {
        method: method,
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      }
      let smsResponse = await fetch(url, requestOptions)
      let jsonResponse = await smsResponse.json()
      let batch = fireStore.batch()
      let total = jsonResponse.getFilteredDeviceListv4Response.return.matchedResults
      for (let sim of jsonResponse.getFilteredDeviceListv4Response.return.deviceList.device) {
        let ICCID = sim.iccid
        batch.set(fireStore.collection('SIMS').doc(ICCID), { ICCID: ICCID, provider: 'Vodafone', api: 'NIBC-API' }, { merge: true })
      }
      batch.commit().then(() => {
        if (500 * loop < total * 1) {
          loop++
          this.getSims(loop)
        }
      })
    }
  },
  computed: {
    customers () {
      return this.$store.getters.customers
    },
    vehicles () {
      return this.$store.getters.vehicles
    }
  }
}
</script>



// WEBPACK FOOTER //
// Import.vue?f8c461c8